import React, { Component } from 'react';
import { Redirect, Switch, Route, withRouter } from 'react-router-dom';

import api from '../utils/api';
import firebase from '../utils/firebase';

import LoginLayout from './layouts/LoginLayout.jsx';
import MainLayout from './layouts/MainLayout.jsx';
import ErrorModal from './_global/ErrorModal.jsx';

import '../styles/App.css';

class App extends Component {

    state = {
        loading: true,
        cover: false,
        errorMessage: ''
    };

    componentDidMount() {

        api.setOnErrorMessage(this.changeErrorMessage);

        this.unregisterAuthObserver = firebase.auth().onAuthStateChanged(user => {

            if (user && !user.emailVerified) {
                this.check();
            }

            api.idToken = null;

            this.setState({ loading: false });
        });
    }

    check() {

        setTimeout(() => {

            const user = firebase.auth().currentUser;

            if (user && user.emailVerified) {
                return this.forceUpdate();
            }

            this.check();

        }, 150);
    }

    componentWillUnmount() {

        this.unregisterAuthObserver();
    }

    logout = () => {

        firebase.auth().signOut();
    };

    onCloseErrorModal = () => {

        this.changeErrorMessage();
    };

    changeErrorMessage = (errorMessage = '', callback) => {

        this.setState({ errorMessage }, callback);
    };

    changeCover = (cover = false, callback) => {

        this.setState({ cover }, callback);
    };

    changeUserDisplayName = (displayName, callback) => {

        firebase.auth().currentUser.updateProfile({ displayName })
            .then(() => callback())
            .catch(callback);

    };

    requestPasswordReset = (email, callback) => {

        firebase.auth().sendPasswordResetEmail(email, {
            url: window.location.href
        })
            .then(callback)
            .catch(callback);
    };

    changeUserEmail = (email, callback) => {

        firebase.auth().currentUser.updateEmail(email)
            .then(() => firebase.auth().currentUser.sendEmailVerification())
            .then(this.logout)
            .then(callback)
            .catch(callback);
    };

    deleteAccount = () => {

        return firebase.auth().currentUser.delete().then(() => {
            window.location = '/';
        });
    };

    HomeHOC = props => {

        if (firebase.auth().currentUser) {

            return (
                <Redirect to="/projects" />
            );
        }

        return (
            <Redirect to="/login" />
        );
    };

    LoginLayoutHOC = props => {

        return (
            <LoginLayout
                {...props}
                {...this.passingProps}
            />
        );
    };

    MainLayoutHOC = props => {

        return (
            <MainLayout
                {...props}
                {...this.passingProps}
            />
        );
    };

    get passingProps() {

        return {
            user: firebase.auth().currentUser,
            changeCover: this.changeCover,
            changeStripeCustomer: this.changeStripeCustomer,
            changeUserDisplayName:this.changeUserDisplayName,
            changeUserEmail:this.changeUserEmail,
            requestPasswordReset:this.requestPasswordReset,
            deleteAccount:this.deleteAccount,
            logout: this.logout,
        };
    }

    get loading() {

        return (
            <div className="app">
                <div className="disabled-cover">
                    <div className="loader">Loading...</div>
                </div>
            </div>
        )
    }

    get error() {

        return (
            <ErrorModal message={this.state.errorMessage} onClose={this.onCloseErrorModal} />
        );
    }

    get cover() {

        return this.state.cover ? (
            <div className="disabled-cover">
                <div className="loader">Loading...</div>
            </div>
        ) : null;
    }

    render() {

        if (this.state.loading) {

            return this.loading;
        }

        return (
            <div className="app">

                {this.error}
                {this.cover}

                <Switch>

                    <Route exact path="/" component={this.HomeHOC} />

                    <Route path="/login" component={this.LoginLayoutHOC} />

                    <Route path="/projects/:id?/:section(comments)?" component={this.MainLayoutHOC} />

                    <Route component={this.HomeHOC} />

                </Switch>

            </div>
        );
    }
}

export default withRouter(App);


// WEBPACK FOOTER //
// ./src/components/App.jsx